import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { ProductFormComponent } from '../../../components/product/product-form/product-form.component';
import { Router } from '@angular/router';

import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-product-index',
  standalone: true,
  imports: [
    CommonModule,
    ProductFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './product-index.component.html',
  styleUrl: './product-index.component.scss'
})
export class ProductIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = ProductFormComponent;

  constructor(
  ) { }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(ProductFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = {
      'copyright': "yes",
      'price': 0,
      'publisher': "uitgeverijneo",
      'first_published_date': new Date().toISOString().split('T')[0],
      // 'end_of_life': new Date().toISOString().split('T')[0],
      'type': 'digital',
      'for_sale': 1,
      'is_demo': 0
    };

    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
